// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UserAddOutlinedSvg from "@fishx/icons-svg/es/asn/UserAddOutlined";
import FishxIcon from '../components/FishxIcon';

var UserAddOutlined = function UserAddOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UserAddOutlinedSvg
  }));
};

UserAddOutlined.displayName = 'UserAddOutlined';
export default React.forwardRef(UserAddOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UserAddOutlined.js
// module id = 4346
// module chunks = 0